import { jsx as i } from "react/jsx-runtime";
import "@market/market-theme/css/components/Tooltip/index.css";
import "@market/market-theme/css/core/index.css";
import { c as m } from "../../../index-PsWX3Tu1.js";
import { forwardRef as p } from "react";
import n from "../styles/MarketTooltip.module.js";
const l = p((o, r) => {
  const {
    children: t,
    className: a,
    ...s
  } = o, e = m(
    n.marketTooltipContainer,
    a
  );
  return /* @__PURE__ */ i(
    "div",
    {
      ref: r,
      className: e,
      ...s,
      children: t
    }
  );
});
l.displayName = "MarketTooltipContainer";
export {
  l as MarketTooltipContainer
};
